import React from 'react';
import s from './MobileBenefits.scss';
import translations from '../../../assets/locales/messages_en.json';
import {
  ContactManager,
  MarketingIntegrations,
  PriceQuotes,
  SEOWizard,
  TasksAndReminders,
  VideoMaker,
} from './MobileBenefitsIcons';
import { useTranslation } from '@wix/wix-i18n-config';
import { useExperiments } from '@wix/wix-experiments-react';
import { VIDEO_MAKER_BENEFIT_KEY } from '../../../constants';

export const MobileBenefits: React.FunctionComponent = () => {
  const PREFIX_TITLE = 'benefits.title.';
  const PREFIX_DESCRIPTION = 'benefits.mobile.';
  const PREFIX_ICON = 'benefits.icon.';

  const getIcon = (id: string) => {
    const arrayOfKeys = Object.keys(translations);
    const arrayOfValues = Object.values(translations);

    const findIndex = arrayOfKeys.indexOf(`${PREFIX_ICON}${id}`);
    const translatedObjectName = arrayOfValues[findIndex];

    switch (translatedObjectName) {
      case 'SEOWizard':
        return <SEOWizard />;
      case 'VideoMaker':
        return <VideoMaker />;
      case 'TasksAndReminders':
        return <TasksAndReminders />;
      case 'ContactManager':
        return <ContactManager />;
      case 'MarketingIntegrations':
        return <MarketingIntegrations />;
      case 'PriceQuotes':
        return <PriceQuotes />;
      default:
        return <SEOWizard />;
    }
  };

  const benefitsKeys = () => {
    return Object.keys(translations)
      .filter((str) => str.startsWith(PREFIX_TITLE))
      .map((str) => str.substring(PREFIX_TITLE.length));
  };

  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const shouldHideVideoMaker = experiments.enabled(
    'specs.ascend.PackagePickerRemoveVideoMaker',
  );
  const benefitsKeysArray = benefitsKeys().filter(
    (key) => !shouldHideVideoMaker || key !== VIDEO_MAKER_BENEFIT_KEY,
  );

  return (
    <div className={s.strip}>
      <div className={s.root}>
        <div className={s.title} data-hook="mobile-benefits-title">
          {t('benefits.mobile.title')}
        </div>
        <div className={s.listOfBenefits}>
          {benefitsKeysArray.map((id) => (
            <div key={id} className={s.benefit}>
              <div
                className={s.benefitIcon}
                data-hook="mobile-benefits-benefitIcon"
              >
                {getIcon(id)}
              </div>
              <div className={s.benefitTextBox}>
                <div
                  className={s.benefitTitle}
                  data-hook={`mobile-benefits-benefitTitle-${id}`}
                >
                  {t(`${PREFIX_TITLE}${id}`)}
                </div>
                <div
                  className={s.benefitDescription}
                  data-hook={`mobile-benefits-benefitDescription-${id}`}
                >
                  {t(`${PREFIX_DESCRIPTION}${id}`)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileBenefits;
